import { useAuth } from './useAuth'
import { useQuery } from '@tanstack/react-query'
import { throwOnError } from '../utils/throwOnError'
import { useRef } from 'react'
import { pendingReportRefetchInterval } from './pendingReportPolling'

type UseGetRequisitionsForLabQueryOptions = {
  isEnabled?: boolean
}

export const useGetRequisitionsForLabQuery = (
  options: UseGetRequisitionsForLabQueryOptions = {}
) => {
  const { authFetchLabV2 } = useAuth()
  const polling = useRef({ key: '', deadline: 0 })
  return useQuery({
    queryKey: ['requisitions'],
    enabled: options.isEnabled ?? true,
    // Poll only pending reports, in the foreground. No timeout is treated as a malware verdict.
    refetchInterval: (query) =>
      pendingReportRefetchInterval(
        query.state.data,
        polling.current,
        Date.now()
      ),
    queryFn: async () => {
      const { data, error } = await authFetchLabV2().GET('/requisitions', {
        params: { query: { preview: true } },
        headers: {
          Accept: 'application/vnd.mattilsynet.proveta.labv2+json'
        }
      })
      if (error) {
        throwOnError(error)
      }
      return data
    }
  })
}
